module.exports = __webpack_public_path__ + "static/img/b19.f4a19ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/b19.jpg
// module id = yvJP
// module chunks = 1